class Navbar extends HTMLElement {
  constructor() {
    super();

    this.hamburger = this.querySelector('#navbar-hamburger');
    this.modal = this.querySelector('.navbar-modal');
    this.navbarClose = this.querySelector('.navbar-wrapper-close');
    this.navbarCartIcon = this.querySelector('.navbar-cart-icon');
    this.miniCart = document.querySelector('mini-cart');
    
    this.hamburger.addEventListener('click', this.handleNavBarToggle.bind(this));
    this.navbarCartIcon.addEventListener('click', this.handleNavBarToggle.bind(this))
    this.modal.addEventListener('click', this.handleClose.bind(this));
    this.handleHeaderHeight();
  }

  handleHeaderHeight() {
    document.body.style.setProperty('--mobile-header-height', `${this.getBoundingClientRect().top + 60}px`)

    // debounce scroll
    let timeout;
    window.addEventListener('scroll', () => {
      if (timeout) window.cancelAnimationFrame(timeout)
      timeout = window.requestAnimationFrame(() => {
        document.body.style.setProperty('--mobile-header-height', `${this.getBoundingClientRect().top + 60}px`)
      });
    }, false);

    window.addEventListener('resize', () => {
      if (timeout) window.cancelAnimationFrame(timeout)
      timeout = window.requestAnimationFrame(() => {
        document.body.style.setProperty('--mobile-header-height', `${this.getBoundingClientRect().top + 60}px`)
      });
    }, false);
  }

  handleNavBarToggle(e) {

    e.preventDefault();

    // Check if Monster Cart is active
    const monsterActive = !!document.querySelector('script[src*="/cart_renderer"]');
    const ariaControls = e.currentTarget.getAttribute('aria-controls');

    // Don't open mini-cart if Monster Cart is active
    if (monsterActive && ariaControls === 'mini-cart') {
      return;
    }

    const isHidden = e.currentTarget.getAttribute( 'aria-expanded' ) === 'false';
    e.currentTarget.setAttribute( 'aria-expanded', isHidden );
    document.body.classList.toggle(`is-${ariaControls}-open`);

    this.wrapper = document.querySelector(`#${ariaControls}`)
    isHidden ? bodyScrollLock.lock(this.wrapper) : bodyScrollLock.unlock(this.wrapper);
  }

  handleClose() {
    this.hamburger.setAttribute('aria-expanded', false);
    this.navbarCartIcon.setAttribute('aria-expanded', false);
    const openClasses = document.body.className.split(' ').filter(c => c.includes('open'));
    document.body.classList.remove(openClasses);
    bodyScrollLock.unlock(this.wrapper);
  }

  openMiniCart() {
    // Check if Monster Cart is active
    const monsterActive = !!document.querySelector('script[src*="/cart_renderer"]');
    if (monsterActive) {
      return;
    }

    this.navbarCartIcon.setAttribute('aria-expanded', true);
    document.body.classList.toggle('is-mini-cart-open');
  }
}

customElements.define('site-navbar', Navbar);